import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'legacy-packages/ft-cb';
import classNames from 'classnames';

import MetaDataNode from './MetaDataNode';
import FinalExamMetaDataNode from './FinalExamMetaDataNode';

import 'legacy-src/utility/ItemTags/index.scss';

class ItemTagsTreeRenderer extends React.Component {
  static displayName = 'ItemTagsTreeRenderer';

  static propTypes = {
    section: PropTypes.object,
    tags: PropTypes.array,
    showFullTextButton: PropTypes.bool,
    isFinalExam: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { isFinalExam } = props;

    this.state = {
      isFullText: !isFinalExam,
    };

    this.toggleFullText = this.toggleFullText.bind(this);
    this.onToggleKeyPress = this.onToggleKeyPress.bind(this);
  }

  /**
   * On toggle key press event handler
   * @param {object} event The key press event handler
   * */
  onToggleKeyPress(event) {
    /**
     * 13: Enter
     * 32: Space
     * */
    if ([13, 32].includes(event.which)) {
      event.preventDefault();
      this.toggleFullText();
    }
  }

  toggleFullText() {
    this.setState((prevState) => ({
      isFullText: !prevState.isFullText,
    }));
  }

  render() {
    const { section, tags, showFullTextButton, isFinalExam } = this.props;
    const { isFullText } = this.state;

    const fullTextPrompt = () => {
      let name;
      let size;
      if (isFullText) {
        name = 'remove';
        size = '1em';
      } else {
        name = 'add';
        size = '1.5em';
      }
      return <Icon name={name} size={size} />;
    };

    const { header } = section;
    const ariaLabel = isFullText
      ? `Hide full text for ${header}`
      : `Show full text for ${header}`;
    const isFinalExamClassNamePrefix = isFinalExam ? 'FinalExam' : '';

    const MetaDataNodeComponent = isFinalExam
      ? FinalExamMetaDataNode
      : MetaDataNode;

    return (
      <div className="ItemTagsTreeRenderer">
        <div
          className={`${isFinalExamClassNamePrefix}ItemMetadata__section__header`}
        >
          <h3 className={classNames({ header_medium: !isFinalExam })}>
            {header}
          </h3>
          {showFullTextButton && (
            <span
              aria-label={ariaLabel}
              role="button"
              tabIndex={0}
              className="ItemMetadata__toggle"
              onClick={this.toggleFullText}
              onKeyPress={this.onToggleKeyPress}
            >
              {fullTextPrompt()}
            </span>
          )}
        </div>
        <div
          className={`${isFinalExamClassNamePrefix}ItemMetadata__section__content`}
          aria-live="polite"
        >
          <ul>
            {tags.map((root) =>
              // skip over the true root, which will cause a redundent
              // Big Idea (etc) to appear
              root.tags
                ? root.tags.map((c) => (
                    <MetaDataNodeComponent
                      nodeLevel={0}
                      showIcon={false}
                      node={c}
                      children={c.tags}
                      isFullText={isFullText}
                      key={c.tag_id}
                    />
                  ))
                : null,
            )}
          </ul>
        </div>
      </div>
    );
  }
}

ItemTagsTreeRenderer.defaultProps = {
  showFullTextButton: false,
  isFinalExam: false,
  section: {},
  tags: [],
};

export default ItemTagsTreeRenderer;
